export enum ALERT_TYPE {
  INCENTIVES = 1,
  PRICING = 2,
  COMMUNITY_REVIEWS = 3,
  COMMPETITORS_REVIEWS = 4,
}
